<template>
  <div>
    <van-nav-bar title="天力爱心基金会会员卡" left-text="" left-arrow @click-left="onClickLeft()" style="margin-top:10px;"/>
    <div v-if="!isLogined" style="padding-top:300px;">
      <p>您还没有登录哦，请先登录</p>
      <van-button round @click="ShowLogin" type="info">点击登录</van-button>
    </div>
    <div v-else>
        <div v-if="isDraw==0" style="padding-top:300px;" class="nomain">
          <p>您还不是天力爱心基金会会员哦</p>
        </div>
        <div v-else>
          <img class="my-swipe" src="../assets/draw3/card.png" fit="contain" alt="" />
          <van-divider content-position="left">详细介绍</van-divider>
          <van-notice-bar
            wrapable
            :scrollable="false"
          style="text-align:left;">
          感谢您对天力爱心基金会的支持，
          您已正式成为天力爱心基金会会员，
          日后您或您的直系亲属（配偶、子女、父母）因病因残至困，
          可向天力爱心基金会提出书面申请，经核实之后将予以爱心资助。 
          </van-notice-bar>
          <van-divider content-position="left">联系方式</van-divider>
          <van-notice-bar
            wrapable
            :scrollable="false"
          style="text-align:left;">
          400-189-1892
          </van-notice-bar>
        </div>
      </div>
  </div>
  
</template>

<script>
import { NavBar, NoticeBar, Image, } from "vant";
import { Button } from "vant";
import { Divider } from "vant";

export default {
  name: "MemberCard",
  data() {
    return { 
      sdworkerId: 0,  
      isDraw: 0, 
    };
  },
  props: {},
  computed:{
    isLogined(){return this.$store.state.isLogin}
  },
  methods: {
    ShowLogin(){
      // this.$store.commit("showLogin");
      this.$router.push({
        name: "Login",
        params: {},
      });
    },
    
    GetData(){
      var that=this;
      if(that.isLogined){
        that.$http.get("SDWorker/Get3LogBySDWorkerId", {
            params: {
              sdworkerId: that.sdworkerId,
            }
          }).then(res=>{ 
            if(res.data.ListData.length>0){
              that.isDraw=1;
            }		
        });
      }
    },
    /*返回 */
    onClickLeft() {
      this.$router.back(-1);
    },
  },
  created() {
    this.sdworkerId = this.$route.params.sdworkerid;
    this.GetData();
  },
  components: {
    [Divider.name]: Divider,
    [Button.name]: Button,
    [NavBar.name]:NavBar,
    [NoticeBar.name]:NoticeBar,
    [Image.name]:Image,
  },
};
</script>


<style scoped>
  
    

  .my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  height: 200px;
}
.my-swipe {
  width: 100%;;
}

.nomain{
  text-align: center;
}

</style>
